import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { Button, Column, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { WHY_CHOOSE_EMAJIN_GOL_POINT_ITEMS } from './constants'
import ImageContainer from './ImageContainer'
import { Container, Content } from './styles'

function WhyChooseEmajinGolfPoints() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()
  const router = useRouter()

  const handleClick = useCallback(
    (link?: string) => {
      if (!link) return

      router.push(link)
    },
    [router],
  )

  const isNotDesktop = !isWideDesktop && !isDesktop

  return (
    <Container
      gap={[0, 0, 64, 64, 80]}
      pb={[64, 64, 64, 64, 120]}
      pt={[0, 0, 64]}
    >
      {WHY_CHOOSE_EMAJIN_GOL_POINT_ITEMS.map((item, index) => (
        <Content
          flexDirection={[
            'column',
            'column',
            'column',
            'column',
            index % 2 !== 0 ? 'row' : 'row-reverse',
          ]}
          gap={[0, 0, 32, 32, 64]}
          key={item.id}
          px={LANDING_CONTENT_PX}
        >
          <ImageContainer item={item} />

          <Column
            alignCenter={isNotDesktop}
            alignStart={!isNotDesktop}
            maxWidth={isNotDesktop ? 420 : 'unset'}
            width={[1, 1, 1, 1, 1 / 2]}
          >
            <Text
              body
              center={isNotDesktop}
              my={[6, 6, 6, 6, 9]}
              regular
              screen14={isNotDesktop}
              screen18={!isNotDesktop}
            >
              {item.plainText}
            </Text>

            {item.link && (
              <Button large onClick={() => handleClick(item.link)}>
                {item.buttonCaption}
              </Button>
            )}
          </Column>
        </Content>
      ))}
    </Container>
  )
}

export default WhyChooseEmajinGolfPoints
